//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mdiSendOutline } from '@mdi/js'
import { ref } from '@vue/composition-api'
import InvoiceEditable from '../InvoiceEditable.vue'

export default {
  components: {
    InvoiceEditable,
  },
  setup() {
    const invoiceData = ref({
      invoiceData: {
        id: 5037,
        issuedDate: '',
        service: '',
        total: '',
        avatar: '',
        invoiceStatus: '',
        balance: '',
        dueDate: '',
        client: {},
      },
      paymentDetails: {
        totalDue: '$12,110.55',
        bankName: 'American Bank',
        country: 'United States',
        iban: 'ETD95476213874685',
        swiftCode: 'BR91905',
      },
      purchasedProducts: [
        {
          itemTitle: '',
          cost: 0,
          hours: 0,
          description: '',
        },
      ],
    })

    const paymentMethods = ['Bank Account', 'PayPal', 'UPI Transfer']

    return {
      invoiceData,
      paymentMethods,

      // Icons
      icons: {
        mdiSendOutline,
      },
    }
  },
}
